import { render } from "./ModalControl.vue?vue&type=template&id=418ebafd&scoped=true"
import script from "./ModalControl.vue?vue&type=script&lang=js"
export * from "./ModalControl.vue?vue&type=script&lang=js"

import "./ModalControl.vue?vue&type=style&index=0&id=418ebafd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418ebafd"]])

export default __exports__